export default function initLogo() {
    const plant = document.getElementById('sh-logo-plant');
    const frame = document.getElementById('sh-logo-frame');


    if (!plant) return;

    const hasAnimated = sessionStorage.getItem('sh-logo-animated');
    const forceAnimate = new URLSearchParams(window.location.search).has('animate-logo');
    const isHomePage = window.location.pathname === '/';

    if (!hasAnimated || forceAnimate || isHomePage) {
        const length = plant.getTotalLength();
        plant.style.setProperty('--plant-length', length);
        sessionStorage.setItem('sh-logo-animated', 'true');
    } else {
        plant.style.animation = 'none';
        plant.style.strokeDasharray = 'none';
        plant.style.strokeDashoffset = '0';
        plant.style.fill = '#9FA165';
        plant.style.strokeOpacity = '0';

        if (frame) { frame.style.animation = 'none'; frame.style.opacity = '1'; }
    }


    // Measure loader plant path length
    const loaderPlant = document.querySelector('.sh-transition-loader #sh-logo-plant');
    if (loaderPlant) {
        const length = loaderPlant.getTotalLength();
        loaderPlant.style.setProperty('--loader-plant-length', length);
    }

}
